module.exports = __webpack_public_path__ + "img/scb.89a791f0.svg";